import { render, staticRenderFns } from "./PerformanceBand.vue?vue&type=template&id=287da643&scoped=true"
import script from "./PerformanceBand.vue?vue&type=script&lang=js"
export * from "./PerformanceBand.vue?vue&type=script&lang=js"
import style0 from "./PerformanceBand.vue?vue&type=style&index=0&id=287da643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287da643",
  null
  
)

export default component.exports